export const SERVICE_DETAIL_FETCH = 'SERVICE_DETAIL_FETCH';
export const SERVICE_DETAIL_SUCCESS = 'SERVICE_DETAIL_SUCCESS';
export const SERVICE_DETAIL_FAILURE = 'SERVICE_DETAIL_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/ServiceDetail/actionTypes.js